import { FeatureAlert, useUltimateAlerts } from "../../context/ultimateAlertsContext"
import useStrings from "../../localization/useStrings"
import Popup from "../Popup/Popup"
import styles from "./SubfeaturesPopup.module.scss"

export interface Feature {
  title: string
  description: string
  imageClass: string
  comingSoon?: boolean
}

interface Props {
  title: string
  headerImageClass: string
  type: FeatureAlert
  features: Feature[]
}

const SubfeaturesPopup = (props: Props) => {
  const strings = useStrings()
  const { state, actions } = useUltimateAlerts()

  const visible = state.showFeatureAlert == props.type

  return (
    <Popup
      title={props.title}
      ctaTitle={strings.gotIt}
      visible={visible}
      headerImageClass={props.headerImageClass}
      onClose={() => {
        actions.setShowFeatureAlert(null)
      }}
    >
      <div className={styles.subfeaturesContainer}>
        {props.features.map((feature, index) => {
          return <SubfeatureItem key={index} feature={feature} />
        })}
      </div>
    </Popup>
  )
}

interface SubfeatureItemProps {
  feature: Feature
}

const SubfeatureItem = (props: SubfeatureItemProps) => {
  const strings = useStrings()

  return (
    <div className={styles.item}>
      <div className={styles.titleContainer}>
        <div className={`${styles.image} ${props.feature.imageClass}`} />
        <label className={styles.title}>{props.feature.title}</label>
        {props.feature.comingSoon && <div className={styles.comingSoon}>{strings.comingSoon}</div>}
      </div>
      <label className={styles.description}>{props.feature.description}</label>
    </div>
  )
}

export default SubfeaturesPopup
